import React, {useState, useEffect} from "react"
import {FunctionComponent} from "react"
import {useUserPreferences} from "../../../common/contexts/UserPreferencesContext"
// icons
import {IconContext} from "react-icons/lib"
import Button from "@murphy-frontend/web-core/components/Button"
import {useNavigate} from "react-router-dom"
import { TbConfetti } from "react-icons/tb"


interface CompletedProps {
	customerId: string
	categoryId: number
	categoryName: string
	nextCategory?: string
	isLastCategory: boolean
}

const Completed: FunctionComponent<CompletedProps> = ({
	customerId,
	categoryId,
	categoryName,
	nextCategory,
	isLastCategory
}) => {
	const navigate = useNavigate()
	const {translations} = useUserPreferences()
	const handleNavigation = () => {
		if (isLastCategory) navigate(`/tmsAssessmentResult`)
		else navigate(`/questionnaire/${customerId}/${categoryId}?survey=true`)
	}

	return (
		<section className='completed-cont'>
			<IconContext.Provider value={{className: "btn-icon btn-comp"}}>
				<TbConfetti />
			</IconContext.Provider>
			<h1>{translations.evalve || 'Evaluation of '}{categoryName}{translations.evalveComplete || ' Completed'}</h1>
			<p>{translations.carryOn || 'We now know more about your organization’s crisis management capacity. Let’s carry on.'}</p>
			<Button buttonStyle={"btn--primary"} buttonSize={"btn--medium"} onClick={handleNavigation}>
				{isLastCategory ? (
					<>{translations.continueResult || 'Continue to Results'}</>
				) : (
					<>
						{translations.continueWith ||'Continue with'} <strong>&nbsp; {nextCategory}</strong>
					</>
				)}
			</Button>
		</section>
	)
}

export default Completed
